import { IBrandPromoCollection } from "@faire/web-api--source/indigofair/data/IBrandPromoCollection";
import { useCallback } from "react";

export const useIsPreOrderExcludedForBrandPromo = () => {
  return useCallback(
    (
      eventKey: string | undefined,
      shipAvailability:
        | keyof typeof IBrandPromoCollection.ProductShipAvailability
        | undefined
    ): boolean => {
      return (
        eventKey !== undefined &&
        shipAvailability ===
          IBrandPromoCollection.ProductShipAvailability
            .ONLY_IMMEDIATE_PRODUCTS_DISCOUNTED
      );
    },
    []
  );
};
